// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserReviewStars_wrapper__4zPTZ"};